export default "__VITE_ASSET__f12c7e68__"